(function () {
    'use strict';

    angular
        .module('salesflare.components.largerprospectfollowup', ['salesflare.components.largerprospectfollowup.onboardingQuestions', 'salesflare.components.largerprospectfollowup.talkToUsInfo', 'salesflare.components.largerprospectfollowup.youCanBookMeForm']);
})();
